export const whitelistReasonOptions = [
  {
    value: 1,
    label: '法务审核可白名单',
  },
  {
    value: 2,
    label: '商务要求特批',
  },
  {
    value: -1,
    label: '其他',
  },
]

export function getWhitelistReasonLabel(reasonId) {
  const option = whitelistReasonOptions.find(
    (item) => item.value === Number(reasonId),
  )
  return option ? option.label : '-'
}
